<!-- /src/views/Directory.vue -->
<template>
  <LayoutTwoColumn class="layout--directory">
    <template v-slot:sidebar>
      <Filters
        :headline="'Corporate Directory'"
      />
      <div class="floating-menu">
        <div
          ref="menu-container"
        >
          <div 
            v-show="showMenu"
          >
            <SubMenu :menuItems="submenuObjsDepartments" :scrollSpyID="'departments'"/>
            <SubMenu :menuItems="submenuObjsResources" :scrollSpyID="'resources'" :scrollSpyActive="{class: 'resources-active'}" />
          </div>
          <button v-if="isMobile"
            class="mobile-menu--trigger"
            @click="toggleMenu"
          >
            <span v-if="!showMenu">Show Directory Menu</span>
            <span v-else>Hide Directory Menu</span>
          </button>
        </div>
        <div class="floating-menu--hover"
          :class="{'is-mobile': isMobile}"
        >
          <!-- <div class="floating-menu--container"
            :class="{active: showMenu}"
            :style="{width: menuWidth+'px'}"
          >
            <SubMenu :menuItems="submenuObjsDepartments" :scrollSpyID="'departments'"/>
            <SubMenu :menuItems="submenuObjsResources" :scrollSpyID="'resources'" :scrollSpyActive="{class: 'resources-active'}" />
          </div> -->
          <button 
            class="floating-menu--trigger"
            :class="{visible: showMenuTrigger, active: showMenu}"
            @click="scrollToTop"
          > <span v-if="!isMobile">Directory Menu</span>
          <i v-else class="icon fas fa-chevron-circle-up"></i></button>
        </div>
      </div>
    </template>
    <template v-slot:content>
      <div class="main-content">
        <div v-if="departments.length > 0"
          class="departments"
          v-scroll-spy
          data-scroll-spy-id="departments"
        >
          <div v-for="(department, index) in departments"
            :key="`departments_ind_${index}`"
            class="departments--individual--container"
          >
            <header class="department"
              :class="hasSubDepts(department)"
            >
              <h2>
                {{ department.title }}
              </h2>
              <div v-if="department.contact"
                class="contact-info contact-info--department"
              >
                <a v-if="department.contact.phone"
                  :href="`tel:${department.contact.phone}`"
                  class="contact--phone bold"
                >{{ department.contact.phone }}</a>
                <a v-if="department.contact.email"
                  :href="`mailto:${department.contact.email}`"
                  class="contact--email bold"
                >{{ department.contact.email }}</a>
              </div>
              <div v-if="department.lead.length > 0"
                class="lead--container lead--container--department">
                <div v-for="(lead, leadIndex) in department.lead"
                  :key="`deptleads_ind_${index}_${leadIndex}`"
                  class="lead--individual lead--individual--department"
                >
                  <div v-if="lead.bio_images"
                    class="lead--image">
                    <img :src="lead.bio_image" alt="">
                  </div>
                  <div class="lead--content">
                    <h4>{{ lead.name }}</h4>
                    <div v-if="lead.contact"
                      class="contact-info contact-info--department"
                    >
                      <a v-if="lead.contact.phone"
                        :href="`tel:${lead.contact.phone}`"
                        class="contact--phone"
                      >{{ lead.contact.phone }}</a>
                      <a v-if="lead.contact.email"
                        :href="`mailto:${lead.contact.email}`"
                        class="contact--email"
                      >{{ lead.contact.email }}</a>
                    </div>
                  </div>
                </div>
              </div> <!-- //lead--container -->
            </header>

            <div v-if="department.subdepts.length > 0"
              class="departments--individual">
              <div class="departments--container departments--sub--container">
                <div v-for="(subdept, subind) in department.subdepts"
                  :key="`subdepart_ind_${index}_${subind}`"
                  class="departments--sub--individual"
                >
                  <header v-if="subdept.title != '' || subdept.contact.phone || subdept.contact.email"
                  >
                    <h3 v-if="subdept.title != ''"
                    >{{ subdept.title }}</h3>
                    <div v-if="subdept.contact"
                      class="contact-info"
                    >
                      <a v-if="subdept.contact.phone"
                        :href="`tel:${subdept.contact.phone}`"
                        class="contact--phone"
                      >{{ subdept.contact.phone }}</a>
                      <a v-if="subdept.contact.email"
                        :href="`mailto:${subdept.contact.email}`"
                        class="contact--email"
                      >{{ subdept.contact.email }}</a>
                    </div>
                  </header>
                  
                  <div v-if="subdept.description != ''"
                    class="description"
                    v-html="subdept.description"
                  ></div>
                  <div class="lead--container lead--sub--container">
                    <div v-for="(lead, leadIndex) in subdept.lead"
                      :key="`leads_ind_${index}_${subind}_${leadIndex}`"
                      class="lead--individual"
                    >
                      <div v-if="lead.bio_images"
                        class="lead--image">
                        <img :src="lead.bio_image" alt="">
                      </div>
                      <div class="lead--content">
                        <h4>{{ lead.name }}</h4>
                        <div v-if="lead.contact"
                          class="contact-info"
                        >
                          <a v-if="lead.contact.phone"
                            :href="`tel:${lead.contact.phone}`"
                            class="contact--phone"
                          >{{ lead.contact.phone }}</a>
                          <a v-if="lead.contact.email"
                            :href="`mailto:${lead.contact.email}`"
                            class="contact--email"
                          >{{ lead.contact.email }}</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> <!-- //departments--container.departments--sub--container -->
            </div> <!-- //departments--individual -->
          </div>
        </div> <!-- //departments -->
        <Loader v-else-if="loadingFeatured" color="gray" />
        <div v-if="globalResources.length > 0"
          class="resources"
          v-scroll-spy="{offset: 50}"
          data-scroll-spy-id="resources"
        >
          <h2 id="other-resources" class="uppercase mb-1">Other Resources</h2>
          <div class="resources--container">
            <a v-for="(resource, rKey) in globalResources"
              :key="rKey"
              :href="resource.type == 'url' ? resource.link.url : (resource.type == 'file' ? resource.file.url : false)"
              :target="resource.type == 'url' && resource.link.target != false ? resource.link.target : false"
              class="resources--individual"
              :class="resource.type == 'url' ? 'resources--link' : (resource.type == 'file' ? 'resources--download' : false)"
              :download="resource.type == 'file' ? true : false"
            ><h3>{{ resource.name }}</h3>
              <div class="resources--description" v-html="resource.description"></div>
            </a>
          </div>
        </div>

      </div>
    </template>
  </LayoutTwoColumn>
</template>

<script>
import LayoutTwoColumn from '@/components/layouts/TwoColumn-SidebarNarrow'
import SubMenu from '@/components/common/Sidebar/SubMenu'
import Filters from '@/components/common/Sidebar/Filters'
import Loader from '@/components/common/Loaders/Loader'
import resizeMixin from '@/mixins/resizeMixin'


export default {
  data() {
    return {
      showMenu: false,
      showMenuTrigger: false,
      scrollPosition: 0,
      menuHeightShow: 0,
      menuWidth: 0,
    }
  },

  computed: {
    departments() {
      const departments = this.$store.getters['options/getOptionPosts'](
        'departments',
      )
      // console.log(departments);
      return departments
    },
    globalResources() {
      const globalResources = this.$store.getters['options/getOptionPosts'](
        'globalResources',
      )
      return globalResources
    },
    submenuObjsDepartments() {
      let output = [];
      const { departments } = this
      Object.values(departments).forEach((val) => {
        output.push(val.title)
      })
      return output
    },
    submenuObjsResources() {
      let output = [];
      output.push('Other Resources')
      return output
    },
  },
  methods: {
    hasSubDepts(dept) {
      return dept.include_subdepts ? 'has-subdepts' : false;
    },
    toggleMenu() {
      this.showMenu = !this.showMenu
    },
    mobileCheck() {
      this.showMenu = !this.isMobile
      // if (this.isMobile == false && this.showMenu == false) this.showMenu = true
    },
    updateScroll() {
      this.scrollPosition = window.scrollY
      this.showMenuTrigger = this.scrollPosition > this.getMenuHeight()
    },
    updateWidth() {
      this.getMenuWidth()
      this.mobileCheck()
    },
    getMenuWidth() {
      this.menuWidth = this.$refs['menu-container'].clientWidth;
    },
    scrollToTop() {
      window.scrollTo(0,0);
      if(this.isMobile && this.showMenu == false) this.toggleMenu()
    },
    getMenuHeight() {
      let menuHeight = this.$refs['menu-container'].clientHeight;
      let menuOffset = this.$refs['menu-container'].offsetTop;
      this.menuHeightShow = (menuOffset + menuHeight)
      return this.menuHeightShow
    }

  },

  mounted() {
    window.addEventListener('scroll', this.updateScroll);
    window.addEventListener('resize', this.updateWidth);
    this.getMenuWidth()
    this.getMenuHeight()
    this.mobileCheck()
    this.$store.dispatch('updatePageTitle', 'Corporate Directory')
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.updateWidth);
    window.removeEventListener('scroll', this.updateScroll)
    this.getMenuWidth()
    this.getMenuHeight()
    this.mobileCheck()
  },

  mixins: [resizeMixin],

  components: {
    LayoutTwoColumn,
    Filters,
    Loader,
    SubMenu,
  },
}
</script>

<style scoped>

.main-content {
  /* margin-left:  */
  margin-bottom: 5em;
}

h2, h3, h4 {
  margin-bottom: 0;
}

.departments {
  font-size: .9em;

  &--individual {

    &--container {
      margin-top: .5em;
      margin-bottom: 1em;
      border-radius: var(--borderRadiusSmall);
      padding-top: 0;
      overflow: hidden;


      &> header {
        background-color: var(--brandPrimary);
        color: white;
        padding: .75em 1.5em;
        line-height: 1.4;

        @media (--tablet) {
          display: grid;
          grid-template-columns: auto 1fr;
          grid-gap: 2em;
          align-items: center;
          justify-items: end;
        }

        .has-subdepts {

        }
        .contact-info {
        }

        h2 {
          font-size: 1.1em;
          font-weight: var(--fontWeightBold);
          line-height: 1.2;
        }

      }
    }
    > .lead--container {
      margin-bottom: 1em;
    }
  }

  &--sub {

    &--container {
      display: grid;
      grid-gap: .25em;

      h3 {
        text-transform: uppercase;
        font-size: .9em;
        color: var(--brandPrimary);
        font-weight: var(--fontWeightBold);
        line-height: 1;
      }

      header {
        display: grid;
        margin-bottom: .25em;
        border-bottom: 1px solid var(--brandPrimary);
        padding-bottom: .25em;
        grid-template-columns: auto 1fr;
        justify-items: end;
        align-items: center;
      }

    }

    &--individual {
      /* border: 1px solid var(--brandAccent); */
      padding: .5em 1.5em .5em 1.5em;
      background-color: white;

      &:last-child {
        border-radius: 0 0 var(--borderRadiusSmall) var(--borderRadiusSmall);
      }
    }
  }
}

.contact-info {
    display: grid;
    grid-gap: .25em;

  @media (--phone) {
    grid-auto-flow: column;
    grid-template-rows: auto;
  }

  a {
    display: block;
    /* color: var(--brandPrimary); */
    color: white;
    border: 1px solid #EEF0F4;
    font-size: .8em;
    font-weight: var(--fontWeightSemibold);
    padding: .25em .75em;
    /* background-color: #EEF0F4; */
    background-color: var(--brandPrimary);
    border-radius: var(--borderRadiusSmall);
    transition: all .3s;

    @media(--phone) {
      display: inline-block;
    }

    &:hover {
      color: var(--brandPrimary);
      background-color: transparent;
    }

    &.bold {
      font-weight: var(--fontWeightBold);
    }

    &:last-child {
      margin-right: 0;
    }
  }

  &--department {
    a {
      background-color: white;
      color: var(--brandPrimary);
      &:hover {
        color: white;
        background-color: var(--brandPrimary);
      }
    }
  }
}


.lead {

  &--container {
    display: grid;
    grid-gap: .25em;

    &--department {
      margin-top: .25em;
      padding-top: .25em;
      border-top: 1px solid var(--brandAccent);
    }
  }

  &--content {

    @media (--desktop) {
      display: grid;
      grid-template-columns: auto 1fr;
      width: 100%;
      grid-gap: 1em;
      align-items: center;
      justify-items: end;
    }
  }

  &--individual {

    h4 {
      font-weight: var(--fontWeightSemibold);
      color: var(--brandAccent);
    }

    .contact-info {
      @media (--desktop) {
        justify-content: end;
      }
    }

    &--department {
      h4 {
        color: white;
        font-weight: var(--fontWeightSemibold);
      }
    }
  }

  &--image {
    img {
      border-radius: 50%;
      width: 100px;
      height: auto;
    }
  }
}

.description {
  font-size: .9em;
  margin-bottom: .5em;
}

.resources {
  font-size: .9rem;

  h2 {
    text-transform: uppercase;
    margin-bottom: 1em 0 .5em 0;
  }

  h3 {
    font-weight: var(--fontWeightSemibold);
    color: var(--brandAccent);
  }
  &--container {
    display: grid;
    grid-gap: .5em;
    grid-template-columns: repeat(auto-fill, minmax(13rem, 1fr));
  }

  &--individual {
    padding: 1em;
    background-color: white;
    border-radius: var(--borderRadiusSmall);
    transition: background-color .3s;

    &:hover {
      background-color: rgba(255,255,255, .6);
    }
  }

  &--description {
    font-size: .9em;
  }
}

.floating-menu {
  &--container {
    /* display: table-row; */
    box-sizing: border-box;
    transition: all .5s;
    visibility: collapse;
    opacity: 0;
    background-color: #E0E3E9;
    padding: 2em;
    margin-left: -2em;
    width: inherit;

    &.active {
      visibility: visible;
      opacity: 1;
    }

  }
  
  &--trigger {
    padding: .5em 1em;
    transition: all .5s;
    visibility: collapse;
    opacity: 0;
    color: white;
    background-color: var(--brandPrimary);
    border-radius: var(--borderRadiusSmall);
    width: inherit;

    &.visible {
      visibility: visible;
      opacity: 1;
    }
  }

    &--hover {
    width: inherit;
    position: fixed;
    bottom: 3em;

    &.is-mobile {
      left: 0;

      .floating-menu--trigger {
        border-radius: 0 var(--borderRadiusSmall) var(--borderRadiusSmall) 0;
      }
    }
  }

}

.mobile-menu {
  &--trigger {
    font-size: .8em;
    padding: .5em 1em;
    transition: all .5s;
    line-height: 1;
    /* visibility: collapse;
    opacity: 0; */
    text-transform: uppercase;
    color: white;
    background-color: var(--brandPrimary);
    border-radius: var(--borderRadiusSmall);
  }

  &--hidden {
    visibility: collapse;
    opacity: 0;
    transition: all .5s;

    &.is-visible {
      opacity: 1;
      visibility: visible;
    }
  }
}

</style>